import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onClearFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const urgencyOptions = [
    { value: 'all', label: 'All Urgencies' },
    { value: 'Emergency', label: 'Emergency' },
    { value: 'Scheduled', label: 'Scheduled' }
  ];

  const issueTypeOptions = [
    { value: 'all', label: 'All Issue Types' },
    { value: 'Mechanical', label: 'Mechanical' },
    { value: 'Electrical', label: 'Electrical' },
    { value: 'Safety', label: 'Safety' },
    { value: 'Routine Maintenance', label: 'Routine Maintenance' },
    { value: 'Other', label: 'Other' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: '3months', label: 'Last 3 Months' }
  ];

  const hasActiveFilters = 
    filters?.status !== 'all' ||
    filters?.urgency !== 'all' ||
    filters?.issueType !== 'all' ||
    filters?.dateRange !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" strokeWidth={2} />
          <h3 className="text-sm font-semibold text-foreground">Filters</h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="xs"
            onClick={onClearFilters}
            className="text-xs"
          >
            Clear All
          </Button>
        )}
      </div>

      <div className="space-y-4">
        {/* Status Filter */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-2">
            Status
          </label>
          <Select
            value={filters?.status}
            onChange={(e) => onFilterChange('status', e?.target?.value)}
            options={statusOptions}
          />
        </div>

        {/* Urgency Filter */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-2">
            Urgency
          </label>
          <Select
            value={filters?.urgency}
            onChange={(e) => onFilterChange('urgency', e?.target?.value)}
            options={urgencyOptions}
          />
        </div>

        {/* Issue Type Filter */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-2">
            Issue Type
          </label>
          <Select
            value={filters?.issueType}
            onChange={(e) => onFilterChange('issueType', e?.target?.value)}
            options={issueTypeOptions}
          />
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-2">
            Date Range
          </label>
          <Select
            value={filters?.dateRange}
            onChange={(e) => onFilterChange('dateRange', e?.target?.value)}
            options={dateRangeOptions}
          />
        </div>
      </div>

      {/* Filter Info */}
      <div className="pt-4 border-t border-border">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} color="var(--color-primary)" strokeWidth={2} className="flex-shrink-0 mt-0.5" />
          <p className="text-xs text-muted-foreground">
            Use filters to narrow down your service requests by status, urgency, issue type, or date range.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;